import React, { Component } from 'react';
import { TextField, Grid, Typography, MenuItem } from "@material-ui/core";
import ImageUploader from 'react-images-upload';

import './Step.scss';

class AttributForm extends Component {
  
render() {
    return (
	   <>
        <Grid item xs={12}>
            <Typography variant="h6">Attribute</Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
            <TextField
                label="Bezeichnung"
                name="designation"
                variant="outlined"
                required
                fullWidth
				value={this.props.values.designation}
                onChange={this.props.handleChange}
				id={'designation' + this.props.values.id}
				className="step-input"
            />
        </Grid>
        <Grid item xs={12} sm={4}>
            <TextField
                label="Feature-ID"
                name="fid"
                variant="outlined"
                fullWidth
				id={'fid' + this.props.values.id}
				value={this.props.values.fid}
                onChange={this.props.handleChange}
				className="step-input"
            />
        </Grid>
		<Grid item xs={12} sm={12}>
          <TextField
            label="Standort"
            name="standort"
            variant="outlined"
            fullWidth
		    id={'standort' + this.props.values.id}
			value={this.props.values.standort}
            onChange={this.props.handleChange}
			className="step-input"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            id={'zugang' + this.props.values.id}
            select
            label="Zugang"
            name="id_zugang"
		    variant="outlined"
			required
		    fullWidth
		    className="step-input"
            value={this.props.values.id_zugang}
            onChange={this.props.handleChange}
          >
            {this.props.zugang.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'material' + this.props.values.id}
            select
            label="Material"
		    name="id_material"
		    variant="outlined"
		    fullWidth
			disabled={this.props.values.dependZugang}
		    className="step-input"
            value={this.props.values.id_material}
            onChange={this.props.handleChange}
          >
            {this.props.materialSchacht.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'funktion' + this.props.values.id}
            select
            label="Funktion"
		    name="id_function"
		    variant="outlined"
		    fullWidth
			disabled={this.props.values.dependZugang}
		    className="step-input"
            value={this.props.values.id_function}
            onChange={this.props.handleChange}
          >
            {this.props.funktion.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'nutzung' + this.props.values.id}
            select
            label="Nutzung"
		    name="id_nutzung"
		    variant="outlined"
		    fullWidth
			disabled={this.props.values.dependZugang}
		    className="step-input"
            value={this.props.values.id_nutzung}
            onChange={this.props.handleChange}
          >
            {this.props.nutzung.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'status' + this.props.values.id}
            select
            label="Status"
		    name="id_status"
		    variant="outlined"
		    fullWidth
			disabled={this.props.values.dependZugang}
		    className="step-input"
            value={this.props.values.id_status}
            onChange={this.props.handleChange}
          >
            {this.props.status.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={4}>
            <TextField
                label="Deckel-Höhe [m.ü.M.]"
                name="hoehe_deckel"
                variant="outlined"
                fullWidth
				id={'hoehe_deckel' + this.props.values.id}
				value={this.props.values.hoehe_deckel}
                onChange={this.props.handleChange}
				className="step-input"
            />
        </Grid>
        <Grid item xs={12} sm={4}>
            <TextField
                label="Sohlen-Kote [m.ü.M.]"
                name="hoehe_sohle"
                variant="outlined"
                fullWidth
				id={'hoehe_sohle' + this.props.values.id}
				value={this.props.values.hoehe_sohle}
                onChange={this.props.handleChange}
				className="step-input"
            />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'witterung_tag' + this.props.values.id}
            select
            label="Witterung"
		    name="id_witterung_tag"
		    variant="outlined"
		    fullWidth
		    className="step-input"
            value={this.props.values.id_witterung_tag}
            onChange={this.props.handleChange}
          >
            {this.props.witterung.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'witterung_vortag' + this.props.values.id}
            select
            label="Witterung (Vortag)"
		    name="id_witterung_vortag"
		    variant="outlined"
		    fullWidth
		    className="step-input"
            value={this.props.values.id_witterung_vortag}
            onChange={this.props.handleChange}
          >
            {this.props.witterung.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
			id={'bemerkung' + this.props.values.id}
            label="Bemerkung"
            name="bemerkung"
            variant="outlined"
            fullWidth
			value={this.props.values.bemerkung}
            onChange={this.props.handleChange}
			className="step-input"
          />
        </Grid>
		<Grid item xs={12}>
           <Typography variant="h6">Fotos</Typography>
        </Grid>
		<Grid item xs={12}>
           <ImageUploader
               withIcon={true}
			   withPreview={true}
               buttonText='Choose images'
               onChange={this.props.onImgDrop}
               imgExtension={['.jpg', '.gif', '.png', '.gif']}
               maxFileSize={10485760}
           />
		 </Grid>
    </>
	)
}
}

export default AttributForm;
